import React from 'react';

class Industries extends React.Component {
	render() {
		return (
			<div className="fullwidth light">
				<div className="row">
					<div className="twelve columns text-center">
						<h2>Trusted by Security-Critical Industries</h2>
						<p style={{fontSize: '1.1em', marginBottom: '40px'}}>From financial services to healthcare, organizations choose our AMD SEV servers for uncompromising confidentiality</p>
					</div>
				</div>
				<div className="row">
					<div className="four columns">
						<div className="panel bordered">
							<h3>Financial Services & FinTech</h3>
							<hr className="grey" />
							<p>PCI-DSS, GDPR, and regulatory compliance with hardware-backed confidentiality.</p>
						</div>
					</div>
					<div className="four columns">
						<div className="panel bordered">
							<h3>Healthcare & Life Sciences</h3>
							<hr className="grey" />
							<p>Secure infrastructure for patient data and medical research workloads with hardware encryption.</p>
						</div>
					</div>
					<div className="four columns">
						<div className="panel bordered">
							<h3>SaaS & Multi-Tenant Platforms</h3>
							<hr className="grey" />
							<p>Cryptographic isolation between customer workloads with zero-trust architecture.</p>
						</div>
					</div>
				</div>
				<div className="row" style={{marginTop: '20px'}}>
					<div className="four columns">
						<div className="panel bordered">
							<h3>High-Performance Databases</h3>
							<hr className="grey" />
							<p>MySQL, PostgreSQL, MongoDB with NVMe performance and memory encryption.</p>
						</div>
					</div>
					<div className="four columns">
						<div className="panel bordered">
							<h3>Secure Development & CI/CD</h3>
							<hr className="grey" />
							<p>Protect intellectual property and secrets in isolated build environments.</p>
						</div>
					</div>
					<div className="four columns">
						<div className="panel bordered">
							<h3>Confidential AI/ML Workloads</h3>
							<hr className="grey" />
							<p>Train and deploy models on sensitive datasets with hardware-enforced privacy.</p>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default Industries;
